import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import Examenes from '@/modules/examenes';

export default new Vuex.Store({
  modules: {
    examenes: Examenes
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js